export function useMoneyFormat(currency: MaybeRefOrGetter<string>) {
  function toMoney(amount: number) {
    return formatCurrency(amount, undefined, toValue(currency))
  }

  return { toMoney }
}
